export const  helpLinks = [
    { href: '/ajuda/perguntas-frequentes', label: 'Perguntas Frequentes' },
    { href: '/ajuda/como-utilizar-um-cupom', label: 'Como utilizar um cupom' },
]